import React, { useCallback, useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import { TreePicker } from 'rsuite';
import { fetchCategoriesList } from '../api';
import { useLocation } from '../hooks/useLocation';
import { doHref } from '../utils/doHref';
import { goTo } from '../utils/history';
import { EquipmentContext } from '../utils/scope';

const getCatCount = (cat, all) =>
  cat.count +
  all.filter((c) => c.parent === cat.term_id).reduce((a, b) => a + getCatCount(b, all), 0);

const fillCounts = (cats, all) => {
  return cats.map((cat) => {
    const count_with_sub = getCatCount(cat, all);
    return { ...cat, count_with_sub };
  });
};

const listToTree = (list, root_id) => {
  var map = {},
    node,
    roots = [],
    i;

  list = fillCounts(list, list);

  for (i = 0; i < list.length; i += 1) {
    map[list[i].term_id] = i;
    list[i].children = [];
  }

  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (node.parent !== root_id) {
      list[map[node.parent]].children.push(node);
    } else {
      roots.push(node);
    }
  }

  for (i = 0; i < list.length; i += 1) {
    if (list[i].children.length === 0) {
      delete list[i].children;
    }
  }

  return roots;
};

const renderNode = (nodeData) => {
  return (
    <span className="nh-category-combo-item">
      <div className="nh-category-combo-item-img-cont">
        <img src={nodeData.image} />
      </div>
      {nodeData.name}
      {nodeData.count_with_sub > 0 ? ` (${nodeData.count_with_sub})` : ''}
    </span>
  );
};

export const CategoriesCombo = () => {
  const scope = useContext(EquipmentContext);
  const { status, data, error } = useQuery([scope, 'categories'], fetchCategoriesList);

  const {
    params: { category },
  } = useLocation();

  const onChange = useCallback((slug) => {
    goTo(doHref({ category: slug }, true));
  }, []);

  const categories = useMemo(() => {
    if (!data) {
      return [];
    }

    return listToTree(data.items, data.root_id);
  }, [data]);

  if (status === 'error') {
    return <span>Error: {error.message}</span>;
  }
  // console.log(categories);
  return (
    <TreePicker
      defaultExpandAll
      valueKey={'slug'}
      labelKey={'name'}
      value={category}
      data={categories}
      appearance="default"
      placeholder={status === 'loading' ? 'Loading...' : 'Select Category'}
      onChange={onChange}
      renderTreeNode={renderNode}
      renderValue={(value, nodeData, selectedElement) => {
        return renderNode(nodeData);
      }}
    />
  );
};
